export enum OpenAIModel {
  O3Mini = 'o3-mini',
  O1Mini = 'o1-mini',
  O1 = 'o1',
  GPT4OMini = 'gpt-4o-mini',
  ChatGPT4OLatest = 'chatgpt-4o-latest',
  GPT4Omni = 'gpt-4o',
  GPT4Turbo = 'gpt-4-turbo',
  GPT4 = 'gpt-4',
  GPT4TurboPreview = 'gpt-4-turbo-preview',
  GPT4VisionPreview = 'gpt-4-vision-preview',
  GPT432K = 'gpt-4-32k',
  GPT3 = 'gpt-3',
  GPT3Dot5 = 'gpt-3.5',
  GPT35Turbo = 'gpt-3.5-turbo',
  GPT35Turbo16K = 'gpt-3.5-turbo-16k',
  GPT35Turbo32K = 'gpt-3.5-turbo-32k',
  GPT3Dot5Turbo64K = 'gpt-3.5-turbo-64k',
  GPT3Dot5Turbo128K = 'gpt-3.5-turbo-128k',
  GPT3Dot5Turbo256K = 'gpt-3.5-turbo-256k',
  GPT3Dot5Turbo512K = 'gpt-3.5-turbo-512k',
  GPT3Dot5Turbo1024K = 'gpt-3.5-turbo-1024k',
  GPT3Dot5Turbo2048K = 'gpt-3.5-turbo-2048k',
  GPT3Dot5Turbo4096K = 'gpt-3.5-turbo-4096k',
  GPT3Dot5Turbo8192K = 'gpt-3.5-turbo-8192k',
  GPT3Dot5Turbo16384K = 'gpt-3.5-turbo-16384k',
  Davinci = 'davinci',
  Ada = 'ada',
  Babbage = 'babbage',
  Curie = 'curie',
}

export enum DeepSeekModel {
  DeepseekChat = 'deepseek-chat',
  DeepseekReasoner = 'deepseek-reasoner',
}

export enum ClaudeModel {
  Claude35Sonnet = 'claude-3-5-sonnet-20241022', // Claude 3.5 Sonnet
  Claude35SonnetLatest = 'claude-3-5-sonnet-latest', // Claude 3.5 Sonnet latest
  Claude35Haiku = 'claude-3-5-haiku-20241022', // Claude 3.5 Haiku
  Claude35HaikuLatest = 'claude-3-5-haiku-latest', // Claude 3.5 Haiku latest
  Claude3Opus = 'claude-3-opus-20240229', // Claude 3 Opus
  Claude3OpusLatest = 'claude-3-opus-latest', // Claude 3 Opus latest
  Claude3Sonnet = 'claude-3-sonnet-20240229', // Claude 3 Sonnet
  Claude3Haiku = 'claude-3-haiku-20240307', // Claude 3 Haiku
}

export enum GeminiModel {
  Gemini2Flash = 'gemini-2.0-flash-001',
  Gemini1_5Flash = 'gemini-1.5-flash',
}

interface AIProvider {
  label: string
  value: string
  models: string[]
}

export const AI_PROVIDERS: Record<string, AIProvider> = {
  gemini: {
    label: 'Gemini',
    value: 'gemini',
    models: Object.values(GeminiModel),
  },
  openai: {
    label: 'Open AI',
    value: 'openai',
    models: Object.values(OpenAIModel),
  },
  claude: {
    label: 'Antropic (Claude)',
    value: 'claude',
    models: Object.values(ClaudeModel),
  },
  deepseek: {
    label: 'DeepSeek',
    value: 'deepseek',
    models: Object.values(DeepSeekModel),
  },
}
